import {
  IAgGridRadio,
  RadioButtonCellRendered,
} from '../../../../utils/custom-renderer/radio-button-cell-renderer';
import { formatMMDDYYYY } from '../../../../utils/formatting';
import { RemodelOperationalProject } from './remodel-operational-projects';

export enum COLUMN_FIELDS {
  NAME = 'NAME',
  TECHNOLOGY_STRING = 'TECHNOLOGY_STRING',
  ISO_STRING = 'ISO_STRING',
  COD = 'COD',
  AVAILABLE_CAPACITY_AC = 'AVAILABLE_CAPACITY_AC',
}

export function VPPA_COLUMNS(context: RemodelOperationalProject) {
  return [
    {
      maxWidth: 35,
      cellRenderer: RadioButtonCellRendered,
      cellRendererParams: (params) => {
        const agGridRadioParams: IAgGridRadio = {
          isSelected: false,
          project: params.data,
          callback: (detail) => {
            context.selectProject(detail);
          },
        };
        if (
          context.selectedRemodelProjectId &&
          context.selectedRemodelProjectId === params.data.REMODEL_PROJECT_ID
        ) {
          agGridRadioParams.isSelected = true;
        }
        return agGridRadioParams;
      },
      flex: 1,
    },
    {
      field: COLUMN_FIELDS.NAME,
      headerName: 'Name',
      suppressMenu: true,
      flex: 1,
      sortable: false,
    },
    {
      field: COLUMN_FIELDS.TECHNOLOGY_STRING,
      headerName: 'Technology',
      maxWidth: 80,
      suppressMenu: true,
      flex: 1,
      sortable: false,
    },
    {
      field: COLUMN_FIELDS.ISO_STRING,
      headerName: 'ISO',
      maxWidth: 70,
      suppressMenu: true,
      flex: 1,
      sortable: false,
    },
    {
      field: COLUMN_FIELDS.COD,
      headerName: 'COD',
      maxWidth: 80,
      suppressMenu: true,
      flex: 1,
      valueFormatter: (params) => formatMMDDYYYY(params.data.COD),
      sortable: false,
    },
    {
      field: COLUMN_FIELDS.AVAILABLE_CAPACITY_AC,
      headerName: 'Nameplate Capacity',
      suppressMenu: true,
      valueFormatter: (params) => `${params.data.AVAILABLE_CAPACITY_AC} MW`,
      flex: 1,
    },
  ];
}
